import { ChameleonVersionMixin, BooleanAttributeChangedMixin, ChameleonPrefixedMixin, } from '@getgo/chameleon-toolkit';
export function ChameleonElementMixin(Base) {
    return ChameleonVersionMixin('@getgo/chameleon-web 3.20.2')(BooleanAttributeChangedMixin(Base));
}
export function ChameleonPrefixedElementMixin(Base, baseName = '[DEFAULT_NAME]') {
    return ChameleonElementMixin(ChameleonPrefixedMixin(baseName)(Base));
}
